module.exports = __webpack_public_path__ + "img/no_data_school.08a1c08b.png";